import { Box, Button, Typography } from '@mui/material'
import {
  ArrayFieldItemButtonsTemplateProps,
  ArrayFieldItemTemplateProps,
  ArrayFieldTemplateProps,
} from '@rjsf/utils'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import { dashify } from 'utils/dashify'

const useStyles = makeStyles({ name: 'ArrayFieldTemplate' })((theme) => ({
  root: {
    width: '100%',
    '& > ul': {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      // display: 'flex',
      // flexWrap: 'wrap',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
      gap: theme.spacing(2),
      width: '100%',
      margin: '0 auto',
      justifyContent: 'center',
    },

    '& > ul > li': {
      border: `1px solid ${theme.palette.divider}`,
      flex: '1 1 25%',
      // maxWidth: `clamp(200px, calc(50% - ${theme.spacing(1)}), 400px)`,
      [theme.breakpoints.down('md')]: {
        flex: '1 1 100%',
      },
    },
    '& .array_item': {
      padding: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
      gap: theme.spacing(2),
      justifyContent: 'flex-start',
    },

    '& .array_item_add_button': {
      textAlign: 'left',
      width: '100%',
      position: 'sticky',
      top: 0,
      backgroundColor: theme.palette.background.paper,
      paddingBottom: '8px',
      paddingTop: '8px',
      zIndex: 1,
      borderBottom: `1px solid ${theme.palette.divider}`,
      paddingLeft: theme.spacing(2),
    },
    '& .array_item--large': {
      width: '100%',
    },
    '& .array_item > button': {
      alignSelf: 'center',
      marginTop: 'auto',
    },
  },
}))

export function ArrayFieldItemButtonsTemplate(
  props: ArrayFieldItemButtonsTemplateProps,
) {
  return null
}

export function ArrayFieldItemTemplate(props: ArrayFieldItemTemplateProps) {
  return <div>{props.children}</div>
}

export function ArrayFieldTemplate(props: ArrayFieldTemplateProps) {
  const { t } = useTranslation()
  const { classes } = useStyles()

  let description = _.get(props.uiSchema, 'ui:options.description')
  description = Boolean(description)
    ? t(`${dashify(description)}`, {
        defaultValue: description,
        ns: 'project',
      })
    : undefined

  return (
    <div className={classes.root}>
      {description && (
        <Box sx={{ pl: 2 }}>
          <Typography variant="body2" color="textSecondary">
            {description}
          </Typography>
        </Box>
      )}
      {props.canAdd && (
        <Box className={'array_item_add_button'}>
          <Button
            type="button"
            variant="outlined"
            color="primary"
            onClick={props.onAddClick}
            size="small"
            data-testid="bom-details-ws-array-add-item"
          >
            {t('project:additional-working-steps-add-item', 'add new item')}
          </Button>
        </Box>
      )}
      <ul>
        {props.items.map((element, index) => {
          console.log([ArrayFieldTemplate], element)
          const itemProps = element.props as ArrayFieldItemTemplateProps
          const itemSchema = Array.isArray(props.schema.items)
            ? props.schema.items[index]
            : props.schema.items
          const isLargeItem =
            itemSchema &&
            typeof itemSchema === 'object' &&
            Object.keys(itemSchema).length > 4

          return (
            <li
              key={itemProps.itemKey ?? element.key ?? index}
              className={`array_item ${isLargeItem ? 'array_item--large' : ''}`}
            >
              <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                item {index + 1}
              </Typography>
              {element}
              {itemProps.buttonsProps?.hasRemove && (
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={itemProps.buttonsProps.onRemoveItem}
                  disabled={
                    itemProps.buttonsProps.disabled ||
                    itemProps.buttonsProps.readonly
                  }
                  data-testid="bom-details-ws-array-remove-item"
                  size="small"
                >
                  {t(
                    'project:additional-working-steps-remove-item',
                    'remove item',
                  )}
                </Button>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
